module.exports = {
  "id": "ed76caa8-0bf9-439d-a63e-507fe984c737",
  "gtmIds": [
    "GTM-NP9L4JBS",
    "GTM-T2TNT6",
    "GTM-KKS578WK"
  ],
  "startTracking": "after_accepting_cookies",
  "hasInAppVersion": false,
  "group": "moreys",
  "language": "en-US",
  "defaultDateFormat": "WEEKDAY_SHORT_MONTH_SHORT_DAY_INTL",
  "defaultNumberFormat": null,
  "pricingSavingsAmountPrecision": "exact",
  "checkoutTaxesFeesBreakdownDisplayMode": "modal",
  "languages": [
    "en-US"
  ],
  "website": "https://www.pigdog.com",
  "imageDeliveryUrl": "public-assets.spotliodata.com"
}